<template>
<nav class="navbar   is-fixed-top" :class="background_colour" role="navigation" aria-label="main navigation">
  <div class="navbar-brand  ">
    <a href="/" class="navbar-item ">
      <img :src="navbar_logo" />
    </a>


  </div>

 
</nav>
</template>

<script>

  export default {
    name: 'NavBar',
    data: function () {
        return {
          background_colour: process.env.VUE_APP_NAVBAR_COLOUR,
          navbar_logo: process.env.VUE_APP_NAVBAR_LOGO,
        }
    },  
    computed: {
        
      },
      methods: {
          logout() {
            if(confirm('Are you sure you want to logout ?'))
            {
            this.$auth.logout({
              returnTo: window.location.origin
            });
            }
      }
      }
  }
  </script>